export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7978.c9548a3d.jpg";